import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'ngx-delete-facebook-data-check',
  templateUrl: './delete-facebook-data-check.component.html',
  styleUrls: ['./delete-facebook-data-check.component.scss'],
  imports: [CommonModule]
})
export class DeleteFacebookDataCheckComponent implements OnInit {
  /**
   * Facebook deleted data status
   */
  public status: string
  private _destroy$ = new Subject()
  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    let userId = 0
    this.activatedRoute.queryParams.pipe(takeUntil(this._destroy$)).subscribe((o) => {
      userId = o.id
    })
    this.authService
      .deleteFacebookDataConfirmation(userId)
      .pipe(takeUntil(this._destroy$))
      .subscribe((res) => {
        this.status = res['isDeleted']
          ? `No Facebook data available for this user`
          : `We still have Facebook data for this user, if you requested your Facbook data to be deleted and got this message please contact us.`
      })
  }

  ngOnDestroy(): void {
    this._destroy$.next(null)
    this._destroy$.complete()
  }
}
